import { CategoriesMenuNode } from '@main/categories-menu/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CategoriesMenuData, CategoriesMenuState, StateWithCategoriesMenu } from '../categories-menu-state';
import { getFeatureState } from './feature.selector';

export const getCategoriesMenuState: MemoizedSelector<
  StateWithCategoriesMenu,
  StateUtils.LoaderState<CategoriesMenuData>
> = createSelector(getFeatureState, (state: CategoriesMenuState) => state.categoriesMenu);

export const getCategoriesMenuValue: MemoizedSelector<StateWithCategoriesMenu, CategoriesMenuData> = createSelector(
  getCategoriesMenuState,
  (state: StateUtils.LoaderState<CategoriesMenuData>) => StateUtils.loaderValueSelector(state),
);

export const getCategoriesMenuLoading: MemoizedSelector<StateWithCategoriesMenu, boolean> = createSelector(
  getCategoriesMenuState,
  (state: StateUtils.LoaderState<CategoriesMenuData>) => StateUtils.loaderLoadingSelector(state),
);

export const getCategoriesMenuError: MemoizedSelector<StateWithCategoriesMenu, boolean> = createSelector(
  getCategoriesMenuState,
  (state: StateUtils.LoaderState<CategoriesMenuData>) => StateUtils.loaderErrorSelector(state),
);

export const getCategoriesMenuSuccess: MemoizedSelector<StateWithCategoriesMenu, boolean> = createSelector(
  getCategoriesMenuState,
  (state: StateUtils.LoaderState<CategoriesMenuData>) => StateUtils.loaderSuccessSelector(state),
);

export const getCategoriesMenuNode: (
  nodeId: string,
) => MemoizedSelector<StateWithCategoriesMenu, CategoriesMenuNode | undefined> = (
  nodeId: string,
): MemoizedSelector<StateWithCategoriesMenu, CategoriesMenuNode | undefined> =>
  createSelector(getCategoriesMenuValue, (data: CategoriesMenuData) => data.nodes?.[nodeId]);

export const getCategoriesMenuIsOpen: MemoizedSelector<StateWithCategoriesMenu, boolean> = createSelector(
  getCategoriesMenuValue,
  (data: CategoriesMenuData) => data.isOpen,
);
